(() => {
  if (window.Shopify?.designMode || window.IslanderWorkshopNavigation) return;
  const carrier = 'workshop_view';
  const validView = value => /^workshop-[abc]$/.test(value || '');
  const isWorkshop = path => /\/pages\/islander-workshop-experience\/?$/.test(path);
  const removeOldMarker = url => {
    const values = url.searchParams.getAll('ab');
    if (!values.includes('make_your_own_bag')) return false;
    url.searchParams.delete('ab');
    values.filter(value => value !== 'make_your_own_bag').forEach(value => url.searchParams.append('ab', value));
    return true;
  };
  const isPreview = url => [...url.searchParams.keys()].some(key => /^(?:workshop_variant|workshop_debug|preview_theme_id|new[-_]workshop[-_]page(?:_oct26)?$|gb[-_~]|growthbook[-_]|force[-_])/i.test(key));
  const current = new URL(window.location.href);
  if (isPreview(current)) return;
  const root = new URL(window.Shopify?.routes?.root || '/', current.origin).pathname;
  const storefrontPath = path => {
    if (!path.startsWith(root)) return false;
    const relative = path.slice(root.length);
    return !/\.[a-z0-9]+\/?$/i.test(relative) && /^(?:$|(?:pages|products|collections|blogs|search|policies)(?:\/|$))/.test(relative);
  };
  let view = isWorkshop(current.pathname) ? current.searchParams.get('view') : current.searchParams.get(carrier);
  if (!validView(view)) view = undefined;
  const settled = document.querySelector('[data-workshop-experiment][data-native-mode="true"][data-protocol="native-v1"]');
  if (!view && isWorkshop(current.pathname) && window.IslanderWorkshopRoute?.active !== true && /^[ABC]$/.test(settled?.dataset.arm || '')) view = `workshop-${settled.dataset.arm.toLowerCase()}`;

  // This public design choice is never an identifier or proof of experiment enrollment.
  const decorateURL = source => {
    if (typeof source !== 'string' || !source || source.startsWith('#')) return source;
    let url;
    try { url = new URL(source, window.location.href); } catch { return source; }
    if (url.origin !== current.origin || !/^https?:$/.test(url.protocol) || url.username || url.password || isPreview(url) || !storefrontPath(url.pathname) || url.searchParams.has('section_id') || url.searchParams.has('sections')) return source;
    const previous = url.href;
    if (isWorkshop(url.pathname)) {
      if (url.searchParams.has('view') && !validView(url.searchParams.get('view'))) return source;
      removeOldMarker(url);
      if (view) url.searchParams.set('view', view);
      url.searchParams.delete(carrier);
    } else if (view) {
      if (url.searchParams.has('view')) return source;
      url.searchParams.set(carrier, view);
    }
    return url.href === previous ? source : url.href;
  };
  const updateLink = link => {
    if (link.hasAttribute('download') || link.hasAttribute('data-no-workshop-navigation')) return;
    const source = link.getAttribute('href'), next = decorateURL(source);
    if (next && next !== source) link.setAttribute('href', next);
  };
  const updateSearch = form => {
    if (!view || form.method.toLowerCase() !== 'get') return;
    let action;
    try { action = new URL(form.action); } catch { return; }
    if (action.origin !== current.origin || action.pathname !== `${root}search`) return;
    let input = form.querySelector(`input[name="${carrier}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden'; input.name = carrier; form.append(input);
    }
    input.value = view;
  };
  const refresh = (scope = document) => {
    if (scope.matches?.('a[href]')) updateLink(scope);
    if (scope.matches?.('form')) updateSearch(scope);
    scope.querySelectorAll?.('a[href]').forEach(updateLink);
    scope.querySelectorAll?.('form').forEach(updateSearch);
  };
  window.IslanderWorkshopNavigation = {decorateURL, refresh};
  // Remove the retired CTA marker from older bookmarked workshop links as well.
  if (isWorkshop(current.pathname) && removeOldMarker(current)) {
    window.history.replaceState(window.history.state, '', current.href);
  }
  refresh();
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') { if (record.target.matches?.('a[href]')) updateLink(record.target); }
      else record.addedNodes.forEach(node => refresh(node));
    }
  });
  observer.observe(document.documentElement, {subtree: true, childList: true, attributes: true, attributeFilter: ['href']});
  for (const name of ['pointerdown', 'click', 'auxclick', 'contextmenu', 'focusin']) document.addEventListener(name, event => {
    const link = event.target.closest?.('a[href]'); if (link) updateLink(link);
  }, true);
  document.addEventListener('submit', event => { if (event.target.matches?.('form')) updateSearch(event.target); }, true);
  document.addEventListener('islander:workshop-experiment-ready', event => {
    if (!isWorkshop(window.location.pathname) || !/^[ABC]$/.test(event.detail?.arm || '')) return;
    view = `workshop-${event.detail.arm.toLowerCase()}`;
    refresh();
  });
})();
